import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 py-10 pb-32 sm:pb-36" data-id="element-180" data-mp="3gezf99jl213s">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-181" data-mp="3ggka709t7m26">
        <div className="rounded-xl border border-white/10 bg-white/[0.04] p-5" data-id="element-182" data-mp="32ovwwtntqrjm">
          <h2 className="flex items-center gap-2 text-[11px] font-black uppercase tracking-[0.16em] text-gold-400" data-id="element-183" data-mp="36oy1baky1z2l">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="3ug3e1gvl8b8o" />
            Importante avviso educativo
          </h2>
          <p className="mt-3 text-[12px] leading-relaxed text-white/55" data-id="element-185" data-mp="387fpncvpdfs">
            Il Sistema Maestro della TRT™ è una risorsa educativa destinata
            esclusivamente a professionisti sanitari qualificati. Non sostituisce
            il giudizio clinico professionale, le linee guida cliniche
            aggiornate, le informazioni ufficiali sulla prescrizione o
            un’appropriata consulenza specialistica.
          </p>
          <p className="mt-3 text-[12px] leading-relaxed text-white/55" data-id="element-186" data-mp="3l9adtjp9964y">
            Le decisioni cliniche devono sempre essere individualizzate in base
            all’anamnesi del paziente, all’esame clinico, ai risultati di
            laboratorio, ai fattori di rischio, alle normative applicabili e alle
            evidenze scientifiche più aggiornate.
          </p>
        </div>

        <p className="mt-6 text-center text-[11px] font-bold uppercase tracking-[0.14em] text-white/35" data-id="element-187" data-mp="3qazo2x4nlfrz">
          © 2026 Sistema Maestro della TRT™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}